import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isGuest: true,
  isAdmin: false,
  user: null,
  pages: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginUser: (state, { payload }) => {
      state.isGuest = false;
      state.user = {
        id: payload.id,
        login: payload.login,
        email: payload.email ?? null,
        token: payload[`user-token`],
      };
      state.isAdmin = Boolean(payload.is_su);
      state.pages = payload.pages ?? null;
    },
    updateProfile: (state, { payload }) => {
      if (!state.user) return;
      if (payload.login !== undefined) state.user.login = payload.login;
      if (payload.email !== undefined) state.user.email = payload.email;
      if (payload.is_su !== undefined) state.isAdmin = Boolean(payload.is_su);
      if (payload.pages !== undefined) state.pages = payload.pages;
    },
    logoutUser: state => {
      state.isGuest = true;
      state.user = null;
      state.isAdmin = false;
      state.pages = null;
    },
  },
});

const authReducer = authSlice.reducer;
const authReducerActions = authSlice.actions;

export { authSlice, authReducer, authReducerActions };
